<template>
	<div class="top">
		<div class="logo_box">
			<img class="logo" src="../static/home/logo.png" alt="">
		</div>
		<div class="top_option">
			
			<div v-for="(item,index) in top_id" :key="index">
				<div class="option_tow" v-if="index!=1" @click.stop="nuv(index)">
					<div :class="topnum==index?'option_boxcode':'option_box'">
						<div class="option_cn">
							{{item.label}}
						</div>
						<div class="option_en" v-if="lang==1">
							{{item.path}}
						</div>
					</div>
					<div class="mgbox">
						<div class="top_2box bbs" v-if="topnum!=index">
							<img class="top_2" src="../static/home/top_2.png" alt="">
						</div>
						<div class="top_2box" v-if="topnum==index">
							<img class="top_2" src="../static/home/top_2.png" alt="">
						</div>
					</div>
				</div>
				<!--  -->
				<div class="option_tow" v-if="index==1"  @click.stop="nuv(1)">
					<div :class="topnum==1?'option_boxcode':'option_box'">
						<div class="option_cn">
							{{item.label}}
						</div>
						<div class="option_en" v-if="lang==1">
							{{list_en[index]}}
						</div>
					</div>
					<div class="mgbox">
						<div class="top_2box bbs" v-if="topnum!=1">
							<img class="top_2" src="../static/home/top_2.png" alt="">
						</div>
						<div class="top_2box" v-if="topnum==1">
							<img class="top_2" src="../static/home/top_2.png" alt="">
						</div>
					</div>
					
					<div class="drop_downbox">
						<img class="san" src="../static/home/san.png" alt="">
						<div class="drop_down">
							<div class="drop_name pad" @click.stop="tow(0)">
								{{item.children[0].label}}
							</div>
							<div class="drop_name" @click.stop="tow(1)">
								{{item.children[1].label}}
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<div class="top_lang_box">
			<div class="top_yun">
				<iframe width="270" scrolling="no" height="25" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=34&color=%23333333&icon=1&py=wansheng&site=12"></iframe>
			</div>
			<div class="lang_box">
				<div class="lang">
					{{text[lang]}}	<div class="sanjiao"></div>
				</div>
				
				<div class="lang" @click="langfun(1)">
					{{text[1]}}
				</div>
				<div class="lang" @click="langfun(2)">
					{{text[2]}}
				</div>
				<div class="lang" @click="langfun(3)">
					{{text[3]}}
				</div>
				<div class="lang" @click="langfun(4)">
					{{text[4]}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'top',
		data() {
			return {
				topnum:0, 	//顶部选择
				top_id:[],	//
				
				list_en:["HOME","ABOUT US","Travel guide","Culture","virtual","Scenery","News","serves","Online"],
				
				text:[ "","中文简体","EN","JP","KN"],	//语言文字
				
				lang:1,		//语言
			}
		},
		props: {
		      p: Number,
		      required: true
		},
		created() {
			this.topnum = this.p;
			this.lang = JSON.parse(localStorage.getItem("langs")) || 1
			
			this.$axios({
			        url:"/api"+"/site/menu/tree?lang=" + this.lang ,//请求的后台接口
			        method:"get",//get请求方式
					headers:{
						'User-Request-Type': 'riesun_site', 
						'siteid' : 'riesun_site_4bb5eaa35e8b46818a61e069e85b7557',
						'sitesecret' : 'b297dcb1-3a4a-4010-b9a5-3b14c08d55e7',
					},
					params:{
						'siteType':1
					} //传给后台的参数
			    }).then(res=>{
					//头部菜单
					this.top_id = res.data.data
					localStorage.setItem("ids", JSON.stringify(this.top_id));
					// console.log(this.top_id)
			　　//请求成功
			}).catch(error=>{
					console.log(error)
			});
		},
		components: {
			
		},
		methods:{
			nuv(e){
				if(e==0){
					if(this.$route.name == 'home'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'home',query:{nums:0}})
					}
				}
				if(e==1){
					if(this.$route.name == 'overview'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'overview',query:{nums:0}})
					}
				}
				if(e==2){
					if(this.$route.name == 'scenic'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'scenic',query:{nums:0}})
					}
				}
				if(e==3){
					if(this.$route.name == 'culture'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'culture',query:{nums:0}})
					}
				}
				if(e==4){
					window.open('https://www.720yun.com/vr/072jkrumew3',"_blank");
				}
				// 
				
				if(e==5){
					if(this.$route.name == 'guide'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'guide',query:{nums:0}})
					}
				}
				if(e==6){
					if(this.$route.name == 'information'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'information',query:{nums:0}})
					}
				}
				if(e==7){
					if(this.$route.name == 'service'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'service',query:{nums:0}})
					}
				}
				if(e==8){
					if(this.$route.name == 'book'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'book',query:{nums:0}})
					}
				}
				if(e==9){
					if(this.$route.name == 'overview3'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'overview3',query:{}})
					}
				}
			},
			
			langfun(e){		//语言
				this.lang = e		//选择语言文字  第几个
				localStorage.setItem("langs", e);
				this.$axios({
				        url:"/api"+"/site/menu/tree?lang=" + this.lang ,//请求的后台接口
				        method:"get",//get请求方式
						headers:{
							'User-Request-Type': 'riesun_site', 
							'siteid' : 'riesun_site_4bb5eaa35e8b46818a61e069e85b7557',
							'sitesecret' : 'b297dcb1-3a4a-4010-b9a5-3b14c08d55e7',
						},
						params:{
							'siteType':1
						} //传给后台的参数
				    }).then(res=>{
						//头部菜单
						this.top_id = res.data.data
						localStorage.setItem("ids", JSON.stringify(this.top_id));
						if(this.$route.name == 'home'){
							this.$router.replace('/refresh')
						}else{
							this.$router.push({name:'home',query:{nums:0}})
						}
						this.$router.go(0)
				　　//请求成功
				}).catch(error=>{
						console.log(error)
				});
			},
			tow(e){		//第二个跳转
				if(e==0){
					if(this.$route.name == 'overview'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'overview',query:{}})
					}
				}
				if(e==1){
					if(this.$route.name == 'overview2'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'overview2',query:{}})
					}
				}
				if(e==2){
					if(this.$route.name == 'overview3'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'overview3',query:{}})
					}
				}
			},
			
			
			
		},
		
	}
</script>

<style scoped lang="less">
	.top{
		height: 98px;
		width: 1920px;
		position: absolute;
		z-index: 10;
		top: 0;
		left: 0;
		background-color: #fff;
		display: flex;
	}
	.logo_box{
		width: 400px;
		height: 98px;
		
	}
	.logo{
		height: 62px;
		margin: 22px 0 0 240px;
		
	}
	.top_option{
		width: 1120px;
		height: 98px;
		display: flex;
		justify-content: space-evenly;
	}
	.option_box{
		height: 98px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		color: #333333;
	}
		.option_tow:hover{
			.option_box{
				color: #e3742a;
			}
		}
		
		.option_boxcode{
			height: 98px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			color: #e3742a;
		}
	.option_cn{
		font-size: 16px;
		text-align: center;
		text-transform:uppercase;
	}
	.option_en{
		font-size: 12px;
		text-transform:uppercase ;
		text-align: center;
	}
	.option_tow{
		display: flex;
		position: relative;
	}
	.mgbox{
		width: 29px;
		height: 98px;
	}
	.top_2box{
		width: 29px;
		height: 98px;
		position: relative;
	}
	.top_2{
		display: block;
		width: 29px;
		height: 55px;
		position: absolute;
		top: 50%;
		left: 0;
		transform:translateY(-50%);
	}
	.san{
		width: 24px;
		height: 6px;
		display: block;
		margin: auto;
	}
	.drop_downbox{
		width: 105px;
		height: 0px;
		position: absolute;
		top: 98px;
		left: 50%;
		transform:translateX(-50%);
		border-radius: 10px;
		box-sizing: border-box;
		overflow: hidden;
		transition:0.6s all; 
	}
	.drop_down{
		width: 105px;
		height: 90px;
		background-color: #e3742a;
		border-radius: 10px;
	}
		.option_tow:hover .drop_downbox{
			height: 90px;
		}
	.drop_name{
		margin: auto;
		width: 70px;
		height: 40px;
		line-height: 40px;
		border-bottom: 1px dashed #fd9753 ;
		text-align: center;
		font-size: 14px;
		color: #ffffff;
		
		overflow: hidden;           //超出隐藏
		white-space: nowrap;       //超出不换行
		text-overflow:ellipsis;    //超出显示省略号
		position: relative;
		z-index: 15;
	}
		.drop_name:nth-child(2){
			border-bottom: 1px dashed transparent ;
		}
	.drop_name:hover{
		color: #333333;
	}
	.pad{
		
	}
	
	.top_lang_box{
		width: 400px;
		height: 98px;
	}
	.top_yun{
		margin-top: 18px;
	}
	.lang_box{
		width: 185px;
		height: 25px;
		line-height: 25px;
		text-align: center;
		border-radius: 13px;
		border: 1px solid #333333;
		margin-left: 50px;
		font-size: 14px;
		color: #333333;
		overflow: hidden;
		transition:0.6s all;
		background-color: #fff;
	}
	.lang{
		width: 185px;
		height: 25px;
		line-height: 25px;
		text-align: center;
		position: relative;
	}
		.lang_box:hover{
			height: 125px;
		}
		.lang:hover{
			background-color: #d6d6d6;
		}
	.sanjiao{
		border-top: 7px solid transparent;
		border-bottom: 7px solid transparent;
		border-left: 7px solid transparent;
		border-right: 7px solid #333333;
		position: absolute;
		top: 50%;
		right: 18px;
		transform:translateY(-50%);
	}
	
	.lang_box:hover .sanjiao{
		border-top: 7px solid #333333;
		border-bottom: 7px solid transparent;
		border-left: 7px solid transparent;
		border-right: 7px solid transparent;
		position: absolute;
		top: 64%;
		right: 18px;
		transform:translateY(-50%);
	}
	
	// 
	.bbs{
		display: none;
	}
	.option_tow:hover{
		.bbs{
			display: block;
		}
	}
	
</style>